/**
 * Pantalla de inicio de sesión (MSAL redirect).
 *
 * La comparten el dashboard y la pantalla de conexión de agentes
 * (`/connect-agent`). MSAL regresa a la URL actual completa tras el login
 * (`redirectStartPage` por defecto = `window.location.href`), así que una
 * ruta con query string se reanuda sola.
 */

import { useMsal } from '@azure/msal-react'
import { useTranslation } from 'react-i18next'

import { loginRequest } from './msalConfig'

interface LoginScreenProps {
  /** Motivo del login en el contexto de la ruta; por defecto el genérico. */
  subtitle?: string
}

export function LoginScreen({ subtitle }: LoginScreenProps) {
  const { t } = useTranslation(['auth', 'common'])
  const { instance } = useMsal()

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((err) => {
      console.error('[login] redirect failed', err)
    })
  }

  return (
    <div className="h-full overflow-y-auto grid place-items-center px-6 py-16">
      <section className="w-full max-w-md rounded-md border border-line bg-surface p-8">
        <h1 className="font-display text-2xl text-ink">{t('auth:login.title')}</h1>
        <p className="mt-2 font-body text-sm text-ink-muted">
          {subtitle ?? t('auth:login.subtitle')}
        </p>
        <button
          type="button"
          onClick={handleLogin}
          className="mt-6 w-full inline-flex items-center justify-center rounded-md
                     bg-brand px-5 py-2.5 font-ui text-sm text-canvas
                     transition-colors hover:bg-brand-deep
                     focus:outline-none focus:ring-2 focus:ring-brand/40"
        >
          {t('common:actions.sign_in')}
        </button>
      </section>
    </div>
  )
}
